import * as React from 'react';
import { useParams } from 'react-router';
import { entityReset } from '@uncinc/react-drupal-core';
import { useDispatch } from 'react-redux';
import Entity from '../Entity';

const FaqEntity = ({
  prevPath,
}) => {
  const { themeTaxonomyPath } = useParams();
  const dispatch = useDispatch();

  React.useEffect(() => {
    return () => dispatch(entityReset());
  }, [dispatch]);

  return (
    <Entity customPath={`/${themeTaxonomyPath}`} prevPath={prevPath} />
  );
};

export default FaqEntity;

